/* NIKA: KRAUSE/ALVE/CAGSAN спец таблици в описанието — native sticky scroll.
   Портнато от live custom.js. Зарежда се САМО когато описанието съдържа
   .staticField (условен render в snippets/nika-kc-table.liquid).
   Подход: native overflow scroll + position:sticky за frozen колоните.
   JS само за: маркиране на колоните (rowspan/colspan), ширини, desktop
   mouse-drag и sticky хедър. CSS-ът е в assets/nika-kc-table.css. */
(function () {
  'use strict';

  var IMG_DESKTOP = 120;
  var IMG_MOBILE = 96;

  function isKcTable(t) {
    return !!(t && t.querySelector && t.querySelector('.staticField, [data-artikelnummer]'));
  }

  /* Маркирай frozen клетките по ЛОГИЧЕСКА колона (отчита rowspan/colspan). */
  function markCols(t) {
    var spanUntil = {}, rows = t.rows, r;
    for (r = 0; r < rows.length; r++) {
      var cells = rows[r].cells, ci = 0, col = 0;
      while (ci < cells.length) {
        while (spanUntil[col] > r) col++;
        var cell = cells[ci++];
        var cs = cell.colSpan || 1, rs = cell.rowSpan || 1;
        if (col === 0) cell.classList.add('kc-c0');
        else if (col === 1) cell.classList.add('kc-c1');
        if (col === 0 && cs >= 2) cell.classList.add('kc-c0', 'kc-cspan');
        if (rs > 1) {
          for (var k = 0; k < cs; k++) spanUntil[col + k] = Math.max(spanUntil[col + k] || 0, r + rs);
        }
        col += cs;
      }
    }
  }

  function build() {
    document.querySelectorAll('table').forEach(function (t) {
      if (!isKcTable(t) || t.classList.contains('kc-table')) return;
      t.classList.add('kc-table');
      markCols(t);
      /* Tinker: описанието вече обвива таблиците в .rte-table-wrapper —
         ползваме него като скрол контейнер вместо да създаваме нов. */
      var box = t.parentElement;
      if (box && box.classList.contains('rte-table-wrapper')) {
        box.classList.add('kc-scroll');
      } else if (!box || !box.classList.contains('kc-scroll')) {
        box = document.createElement('div');
        box.className = 'kc-scroll';
        t.parentNode.insertBefore(box, t);
        box.appendChild(t);
      }
      var cspan = t.querySelector('.kc-cspan');
      if (cspan && !cspan.querySelector('.kc-arrow')) {
        var arrow = document.createElement('span');
        arrow.className = 'kc-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';
        cspan.appendChild(arrow);
      }
      t.querySelectorAll('th.cg-arrow-host').forEach(function (host) {
        if (!host.querySelector('.kc-arrow')) {
          var a2 = document.createElement('span');
          a2.className = 'kc-arrow';
          a2.setAttribute('aria-hidden', 'true');
          a2.textContent = '›';
          host.appendChild(a2);
        }
      });
    });
  }

  /* Фиксирай ширината на пиктограма колоната и закотви етикет колоната след нея. */
  function position() {
    var mobile = window.matchMedia('(max-width:768px)').matches;
    document.querySelectorAll('table.kc-table').forEach(function (t) {
      var imgW = mobile ? IMG_MOBILE : IMG_DESKTOP;
      t.querySelectorAll('.timage img, .kc-c0 img').forEach(function (im) {
        im.style.setProperty('width', imgW + 'px', 'important');
        im.style.setProperty('max-width', imgW + 'px', 'important');
        im.style.setProperty('height', 'auto', 'important');
      });
      var w0 = imgW + 24;
      t.querySelectorAll('tr > .kc-c0:not(.kc-cspan)').forEach(function (c) {
        w0 = Math.max(w0, Math.ceil(c.getBoundingClientRect().width));
      });
      t.querySelectorAll('.kc-c0:not(.kc-cspan)').forEach(function (c) {
        c.style.setProperty('width', w0 + 'px', 'important');
        c.style.setProperty('min-width', w0 + 'px', 'important');
        c.style.setProperty('max-width', w0 + 'px', 'important');
      });
      t.querySelectorAll('.kc-c1').forEach(function (c) { c.style.left = w0 + 'px'; });

      var c1 = t.querySelector('.kc-c1');
      var labelW = c1 ? Math.ceil(c1.getBoundingClientRect().width) : 132;
      var valSel = 'td:not(.kc-c0):not(.kc-c1),th:not(.kc-c0):not(.kc-c1)';
      if (mobile) {
        var scEl = t.closest ? t.closest('.kc-scroll') : t.parentElement;
        var avail = (scEl ? scEl.clientWidth : window.innerWidth);
        var valW = Math.max(96, avail - w0 - labelW - 1);
        t.querySelectorAll(valSel).forEach(function (c) {
          c.style.setProperty('width', valW + 'px', 'important');
          c.style.setProperty('min-width', valW + 'px', 'important');
        });
      } else {
        t.querySelectorAll(valSel).forEach(function (c) {
          c.style.removeProperty('width');
          c.style.removeProperty('min-width');
        });
      }

      var scEl2 = t.closest ? t.closest('.kc-scroll') : t.parentElement;
      if (scEl2) t.classList.toggle('kc-has-scroll', scEl2.scrollWidth > scEl2.clientWidth + 4);

      if (t._kcStickyRebuild) t._kcStickyRebuild();
      if (t._kcSticky) t._kcSticky();
    });
  }

  /* Desktop: влачене с мишка хоризонтално (touch остава native). */
  function bindMouseDrag(sc) {
    var down = false, moved = false, sx = 0, sl = 0;
    sc.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; sx = e.pageX; sl = sc.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 3) { moved = true; sc.classList.add('kc-grab'); }
      if (moved) { e.preventDefault(); sc.scrollLeft = sl - dx; }
    });
    window.addEventListener('mouseup', function () { down = false; sc.classList.remove('kc-grab'); });
    sc.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* Sticky хедър при вертикален скрол: fixed лента с клонинг на header реда. */
  function setupStickyHeader(t, sc) {
    var bar = document.createElement('div');
    bar.className = 'kc-stickyhead';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    function rebuild() {
      bar.textContent = '';
      var hrow = t.rows[0];
      if (!hrow) return;
      var clone = t.cloneNode(false);
      clone.style.margin = '0';
      var tbody = document.createElement('tbody');
      tbody.appendChild(hrow.cloneNode(true));
      clone.appendChild(tbody);

      var realC = hrow.querySelectorAll('th,td');
      var cloneC = clone.querySelectorAll('th,td');
      for (var i = 0; i < realC.length && i < cloneC.length; i++) {
        var rc = window.getComputedStyle(realC[i]), cc = cloneC[i];
        cc.style.setProperty('width', rc.width, 'important');
        cc.style.setProperty('min-width', rc.width, 'important');
        cc.style.setProperty('max-width', rc.width, 'important');
        cc.style.setProperty('color', rc.color, 'important');
        cc.style.setProperty('background-color', rc.backgroundColor, 'important');
        cc.style.setProperty('padding', rc.padding, 'important');
      }
      var realEls = hrow.querySelectorAll('th,td,th *,td *');
      var cloneEls = clone.querySelectorAll('th,td,th *,td *');
      for (var j = 0; j < realEls.length && j < cloneEls.length; j++) {
        var re = window.getComputedStyle(realEls[j]), ce = cloneEls[j];
        ce.style.setProperty('font-size', re.fontSize, 'important');
        ce.style.setProperty('font-family', re.fontFamily, 'important');
        ce.style.setProperty('font-weight', re.fontWeight, 'important');
        ce.style.setProperty('line-height', re.lineHeight, 'important');
        ce.style.setProperty('color', re.color, 'important');
      }
      clone.style.setProperty('table-layout', 'fixed', 'important');
      clone.style.width = Math.ceil(t.getBoundingClientRect().width) + 'px';
      bar.appendChild(clone);
    }

    function refresh() {
      var hrow = t.rows[0];
      var hr = (hrow || t).getBoundingClientRect();
      var tr = t.getBoundingClientRect();
      var scr = sc.getBoundingClientRect();
      if (hr.top < 0 && tr.bottom > hr.height + 4) {
        bar.style.display = 'block';
        bar.style.left = Math.round(scr.left) + 'px';
        bar.style.width = Math.round(scr.width) + 'px';
        bar.scrollLeft = sc.scrollLeft;
        var ctr = bar.querySelector('tr');
        bar.style.height = Math.ceil((ctr || hrow || t).getBoundingClientRect().height) + 'px';
      } else {
        bar.style.display = 'none';
      }
    }
    t._kcStickyRebuild = rebuild;
    t._kcSticky = refresh;
    rebuild();
    /* Tinker скролва във вътрешен контейнер (html/body са overflow:hidden) —
       capture: true хваща scroll събитията от всеки контейнер. */
    window.addEventListener('scroll', refresh, { passive: true, capture: true });
    sc.addEventListener('scroll', function () { bar.scrollLeft = sc.scrollLeft; }, { passive: true });
    refresh();
  }

  function run() {
    build();
    document.querySelectorAll('table.kc-table').forEach(function (t) {
      var sc = t.closest('.kc-scroll');
      if (sc && !sc._kcBound) {
        sc._kcBound = 1;
        bindMouseDrag(sc);
        setupStickyHeader(t, sc);
      }
    });
    position();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  var tmr;
  window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(position, 150); });
  window.addEventListener('orientationchange', function () { setTimeout(position, 200); });
})();
